import {createReducer, on} from '@ngrx/store';
import { ExportRequestsChildrenActions } from './export-requests-children.actions';
import { ExportRequestsState } from '../export-requests/export-requests.reducer';

export const exportRequestChildrenMapFeatureKey = 'Reporting-export-requests-children-map';

const initialExportRequests: ExportRequestsState = {
    loading: true,
};

export const exportRequestChildrenMapReducer = createReducer<ExportRequestsState>(
    initialExportRequests as ExportRequestsState,
    on(
        ExportRequestsChildrenActions.fetchSuccess,
        (state, { response }): ExportRequestsState => ({
            loading: false,
            hasError: false,
            tableSummary: {rows: response.list?.map(item => ({...item})) },
            totalItems: response.paging.totalItems,
        })
    ),
    on(ExportRequestsChildrenActions.fetchFailure,
        (state, {message}) => ({
            loading: false,
            hasError: true,
            errorMessage: message,
        })
    ),
    on(
        ExportRequestsChildrenActions.search,
        (state, ): ExportRequestsState => ({loading: true})
    ),
);